import { useNavigate } from 'react-router';

import { useCurrentUser } from '@/hooks';
import { Avatar, Chip, Icon } from '@/ui';

import type { User } from '@/types';
import type { MouseEvent } from 'react';

import { isAdmin } from '@/types/user';

interface CoachChipProps {
  coach: User;
  publicView?: boolean;
}

const CoachChip = ({ coach, publicView = false }: CoachChipProps) => {
  const { user: currentUser } = useCurrentUser();
  const navigate = useNavigate();

  const onClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (publicView) {
      navigate(`/m/profiles-coach/${coach.id}`);
      return;
    }
    navigate(`/coach/manage/coaches/${coach.id}`);
  };

  const handleClick = () => {
    if (publicView) return onClick;
    if (isAdmin(currentUser)) return onClick;
    return undefined;
  };

  return (
    <Chip
      avatar={
        <Avatar
          firstName={coach.firstName}
          lastName={coach.lastName}
          src={coach.avatarUrl ?? ''}
        />
      }
      deleteIcon={<Icon>chevron_right</Icon>}
      label={coach.firstName}
      onClick={handleClick()}
      onDelete={handleClick()}
    />
  );
};

export default CoachChip;
